<template>
	<v-dialog
		v-model="isVisible"
		:width="'100%'"
		transition="dialog-bottom-transition"
		content-class="custom-dialog-bottom"
	>
		<div class="dialog-bottom tw-p-10">
			<div class="tw-w-8/12 tw-mx-auto tw-flex">
				<div class="tw-mb-6 tw-flex-auto tw-mr-6">
					<span class="text-info tw-inline-block tw-mb-2">{{
						isEditable ? 'Editar Grado' : 'Agregar Grado'
					}}</span>
					<v-text-field
						solo
						hide-details
						class="input-text"
						v-model="degreeName"
					></v-text-field>
				</div>
				<div class="tw-text-right tw-pt-8">
					<v-btn
						color="primary"
						class="custom-button black"
						style="margin-right: 10px !important;"
						@click="hide"
						>Cancelar</v-btn
					>
					<v-btn
						color="primary"
						class="custom-button"
						@click="save"
						:disabled="!isEnableAdd"
						>{{ isEditable ? 'Guardar' : 'Agregar' }}</v-btn
					>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import { isEmpty, isNil, trim } from 'ramda';
import { getNewDegree } from '../../../../../utils/valuation-model/degree';

const enableCustomDialogBottom = () => {
	const elements = document.getElementsByClassName('custom-dialog-bottom');
	for (let i = 0; i < elements.length; i += 1) {
		elements[i].parentElement.setAttribute('data-dialog-type', 'custom-dialog');
	}
};

export default {
	name: 'AddDegreeDialog',
	data() {
		return {
			isVisible: false,
			degreeName: '',
			degreeToEdit: null,
		};
	},
	mounted() {
		enableCustomDialogBottom();
	},
	computed: {
		isEnableAdd() {
			return !isEmpty(trim(this.degreeName));
		},
		isEditable() {
			return !isNil(this.degreeToEdit);
		},
	},
	methods: {
		show() {
			this.degreeToEdit = null;
			this.degreeName = '';
			this.isVisible = true;
		},
		edit(degreeToEdit) {
			this.degreeToEdit = degreeToEdit;
			this.degreeName = degreeToEdit.name;
			this.isVisible = true;
		},
		hide() {
			this.isVisible = false;
		},
		save() {
			if (this.isEditable) {
				this.$emit('degreeUpdated', {
					updatedDegree: getNewDegree({
						...this.degreeToEdit,
						name: this.degreeName,
					}),
					oldDegree: this.degreeToEdit,
				});
			} else {
				this.$emit('degreeAdded', getNewDegree({ name: this.degreeName }));
			}
			this.isVisible = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.dialog-bottom {
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/AddDegreeDialog.vue